import React, {useState} from "react"
import {Button, Stack} from "@mui/material";
import CustomTextField from "../../../customMUIComponents/CustomTextField";

const SocietyHomepageContactForm = () => {

    const [firstnameForm, setFirstnameForm] = useState<string>('');
    const [lastnameForm, setLastnameForm] = useState<string>('');
    const [societyForm, setSocietyForm] = useState<string>('');
    const [emailForm, setEmailForm] = useState<string>('');
    const [phoneNumberForm, setPhoneNumberForm] = useState<string>('');
    const [messageForm, setMessageForm] = useState<string>('');

    const submit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        alert('Work in progress');
    }

    return (
        <form onSubmit={(e) => submit(e)}>
            <Stack spacing={2} direction="row" sx={{marginBottom: 4}}>
                <CustomTextField
                    value={firstnameForm}
                    label="Prénom"
                    setField={setFirstnameForm}
                    required/>
                <CustomTextField
                    value={lastnameForm}
                    label="Nom"
                    setField={setLastnameForm}
                    required/>
            </Stack>

            <CustomTextField
                value={societyForm}
                label="Société" setField={setSocietyForm}/>

            <Stack spacing={2} direction="row" sx={{marginTop: 4}}>
                <CustomTextField
                    value={emailForm}
                    label="Email"
                    type="email"
                    setField={setEmailForm}
                    required/>
                <CustomTextField
                    value={phoneNumberForm}
                    label="N° téléphone"
                    type="text"
                    setField={setPhoneNumberForm}
                    required/>
            </Stack>

            <CustomTextField
                value={messageForm}
                label="Votre message"
                setField={setMessageForm}
                required
                multiline
                rows={6}
                mt={4}
                mb={4}/>

            <Button
                variant="fourthVariant"
                type="submit"
                fullWidth
            >
                Envoyer
            </Button>
        </form>
    )
}

export default SocietyHomepageContactForm;